export default __webpack_public_path__ + "static/media/OSMOS_NEBBIA_MATT_120X120_03.4cb875dd.jpg";